import { useCallback, useState, useEffect } from 'react';
import { store } from 'redux/store';
import {
  resetCP,
  setSubpage,
  setLocationId,
  setMultiLocationIds,
  setTimeFrequency,
  setModelId,
  setMultiModelIds,
  setForecastDate,
  setVariable,
  setRounds,
  setMembers,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { TrackingForecastPreference } from 'types/Meteorology/Fields/TrackingForecast/DetailedView/preference';
import { Subpage, SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';
import simpleDiffToFormattedDate from 'helper/simpleDiffToFormattedDate';
import { useChartRequestTriggerValue } from './chartRequestTriggerStore';

export default function useSelectPreference() {
  const [shouldTriggerRequest, setShouldTriggerRequest] = useState(false);
  const triggerRequest = useChartRequestTriggerValue();

  const selectPreference = useCallback((preference: TrackingForecastPreference) => () => {
    const { params, submenu } = preference;

    store.dispatch(resetCP());

    const subpage = Object.keys(SUBPAGE_SUBMENU_OPTIONS).find(
      (key) => SUBPAGE_SUBMENU_OPTIONS[key] === submenu,
    );
    if (subpage) {
      store.dispatch(setSubpage(subpage as Subpage));
    }
    if (params.timeFrequency) {
      store.dispatch(setTimeFrequency(params.timeFrequency));
    }
    if (params.variable) {
      store.dispatch(setVariable(params.variable));
    }
    if (params.locationId) {
      store.dispatch(setLocationId(params.locationId));
    }
    if (params.locationIds) {
      store.dispatch(setMultiLocationIds(params.locationIds));
    }
    if (params.modelId) {
      store.dispatch(setModelId(params.modelId));
    }
    if (params.modelIds) {
      store.dispatch(setMultiModelIds(params.modelIds));
    }
    if (params.memberIds) {
      store.dispatch(setMembers(params.memberIds));
    }
    if (params.forecastDate) {
      const formattedDate = simpleDiffToFormattedDate(params.forecastDate, 'yyyy-MM-dd');
      store.dispatch(setForecastDate(formattedDate));
    }
    if (params.forecastDates) {
      const formattedDates = params.forecastDates.map(
        (dateDiffs) => simpleDiffToFormattedDate(dateDiffs, 'yyyy-MM-dd'),
      );
      store.dispatch(setRounds(formattedDates));
    }

    setShouldTriggerRequest(true);
  }, []);

  useEffect(() => {
    if (triggerRequest && shouldTriggerRequest) {
      triggerRequest();
      setShouldTriggerRequest(false);
    }
  }, [triggerRequest, shouldTriggerRequest]);

  return {
    selectPreference,
  };
}
